import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import { routes } from './router'
import { useAuthStore } from './stores/auth'
import { useBrandingStore } from './stores/branding'
import { setupApi } from './api/setup'
import './style.css'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

let authInitialized = false
let setupChecked = false
let needsSetup = false

export function resetSetupCheck() {
  setupChecked = false
}

async function checkSetupOnce() {
  if (setupChecked) return
  try {
    const res = await setupApi.status()
    needsSetup = res.needs_setup
  } catch {
    // 接口失败时放行，避免后端不通时整站不可用；后续路由依然会走鉴权拦截
    needsSetup = false
  }
  setupChecked = true
}

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  await checkSetupOnce()

  if (needsSetup && to.path !== '/setup') {
    next('/setup')
    return
  }

  if (!needsSetup && to.path === '/setup') {
    next(authStore.isAuthenticated ? '/' : '/login')
    return
  }

  if (!authInitialized) {
    authStore.checkAuth()
    authInitialized = true
  }

  const requiresAuth = to.meta.requiresAuth !== false

  if (authStore.isAuthenticated && to.path === '/login') {
    next('/')
    return
  }

  if (!requiresAuth) {
    next()
    return
  }

  if (!authStore.isAuthenticated) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  if (to.meta.requiredRoles) {
    const roles = to.meta.requiredRoles as string[]
    if (!roles.includes(authStore.user?.role || '')) {
      next('/')
      return
    }
  }

  next()
})

const app = createApp(App)
app.use(createPinia())
app.use(router)

// 品牌配置（产品名/Logo/主题/主色）走免登录的公开端点，挂载前拉取可避免登录页
// 先闪默认品牌再跳变。接口失败时 store 内部回退默认值，不阻塞启动。
const brandingStore = useBrandingStore()
brandingStore.applyAll()
brandingStore.fetchBranding().finally(() => {
  app.mount('#app')
})
